// Identifies this form in the analytics service and in the Google Sheet payload.
export const FORM_ID = "EGY_ES_R";

// Value written to the "source" column of the Google Sheet. The internal lead
// system uses it to decide where each lead gets routed.
export const SHEET_SOURCE = "railway-repsol";
export const ANALYTICS_URL = "https://analytics-production-3046.up.railway.app";

// Set REACT_APP_PRIVACY_POLICY_URL at build time with the real policy URL.
export const PRIVACY_POLICY_URL =
  process.env.REACT_APP_PRIVACY_POLICY_URL || "#";
